<template>
    <div>
         <con-tab @TwoClick="TwoClick"></con-tab>
       <!-- 服务商入驻 -->
        <ServiceSettled ></ServiceSettled>
    </div>
</template>

<script>
    import ConTab from "../../components/common/ConTab";
    import ServiceSettled from "./base/Service_Settled";
    // import Qs from 'qs'
    export default {
        name: "Service_settled",
        data(){
            return {
                
            }
        },
        created(){
            
        },
        methods:{
             TwoClick(item){
                //console.log(item);
                this.ConList = item
            },
        },
        components:{
            ConTab,
            ServiceSettled
        }
    }
</script>

<style scoped>

</style>
